export const allianceType = {
  skyteam: "スカイチーム",
  oneworld: "ワンワールド",
  value: "バリュー",
  star: "スター",
};
